import { render, staticRenderFns } from "./editFollowUp.vue?vue&type=template&id=03f71c45&scoped=true"
import script from "./editFollowUp.vue?vue&type=script&lang=js"
export * from "./editFollowUp.vue?vue&type=script&lang=js"
import style0 from "./editFollowUp.vue?vue&type=style&index=0&id=03f71c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f71c45",
  null
  
)

export default component.exports